import { render, staticRenderFns } from "./Teacher.vue?vue&type=template&id=d81b474c&"
import script from "./Teacher.vue?vue&type=script&lang=ts&"
export * from "./Teacher.vue?vue&type=script&lang=ts&"
import style0 from "./Teacher.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports